import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 2000 }
  }

  connect() {
    // Démarrer le polling dès la connexion
    this.startPolling()
  }

  disconnect() {
    // Arrêter le polling lors de la déconnexion
    this.stopPolling()
  }

  startPolling() {
    // Faire une première requête immédiatement
    this.poll()

    // Puis continuer avec l'intervalle défini
    this.pollingTimer = setInterval(() => {
      this.poll()
    }, this.intervalValue)
  }

  stopPolling() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
      this.pollingTimer = null
    }
  }

  async poll() {
    console.log('Polling...', this.urlValue)
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        }
      })

      console.log('Response status:', response.status)

      if (response.ok) {
        const html = await response.text()
        console.log('Response HTML length:', html.length)

        // Si la réponse n'est pas vide (no_content), Turbo va gérer la mise à jour
        if (html.trim()) {
          console.log('Rendering turbo stream and stopping polling')
          // Turbo Streams va automatiquement remplacer le contenu
          // et le polling sera arrêté car le controller sera déconnecté
          Turbo.renderStreamMessage(html)
          this.stopPolling()
        } else {
          console.log('Empty response, continuing polling...')
        }
        // Si c'est no_content (204), on continue le polling
      } else {
        console.error('Polling error:', response.status)
        this.stopPolling()
      }
    } catch (error) {
      console.error('Polling error:', error)
      this.stopPolling()
    }
  }
}
